import { getLocalStorage, setLocalStorage } from "constants/local-storage"
import { omit } from "lodash-es"
import { ACTIONS, CallBackProps, EVENTS, Props, STATUS } from "react-joyride"
import { mountStoreDevtool } from "simple-zustand-devtools"
import create from "zustand"

export enum Walkthrough {
  CREATE_ROUTE = "fsmCreateRouteWalkthrough",
  CREATE_BEAT = "fsmCreateBeatWalkthrough",
}

type WalkthroughState = Pick<Props, "stepIndex" | "run" | "steps"> & {
  type: Walkthrough
  completed: Record<string, string>
}
type FSMWalkthrough = {
  state: WalkthroughState
  setState: (state: Partial<WalkthroughState>) => void
  handleJoyrideCallback: (data: CallBackProps) => void
}
const useFSMWalkthrough = create<FSMWalkthrough>((set, get) => ({
  state: {
    run: false,
    stepIndex: 0,
    steps: [],
    type: Walkthrough.CREATE_ROUTE,
    completed: getLocalStorage("completed") ? getLocalStorage("completed") : {},
  },
  setState(state) {
    set({ state: { ...get().state, ...state } })
  },
  handleJoyrideCallback(data: CallBackProps) {
    const walkType = get().state.type
    const completed = get().state.completed
    const { type, status, action, index } = data
    if (type === EVENTS.TOUR_START) {
      const newCompleted = omit(completed, [walkType])
      setLocalStorage("completed", newCompleted)
      get().setState({ completed: newCompleted })
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type as any)) {
      // Update state to advance the tour
      get().setState({
        stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
      })
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status as any)) {
      const newCompleted = { ...completed, [walkType]: "1" }
      setLocalStorage("completed", newCompleted)
      // Need to set our running state to false, so we can restart if we click start again.
      get().setState({ run: false, completed: newCompleted, steps: [] })
    }
  },
}))
if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("WalkthroughStore", useFSMWalkthrough)
}
export default useFSMWalkthrough
